import { z } from 'zod'

export const IceBreakerSchema = z.object({
  icebreaker_id: z.number(),
  caption: z.string(),
  sort_id: z.number(),
  status: z.number(),
  chns: z.string(),
  flow_ns: z.string(),
  template_installation_id: z.number().nullable(),
})
